import { render, staticRenderFns } from "./LoginByWa.vue?vue&type=template&id=e71aa87c&"
import script from "./LoginByWa.vue?vue&type=script&lang=js&"
export * from "./LoginByWa.vue?vue&type=script&lang=js&"
import style0 from "./LoginByWa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VContainer,VOtpInput,VOverlay,VProgressCircular,VSnackbar,VTextField})
